import { BrowserMicroSentryClient } from '@micro-sentry/browser';

const release = process.env.REACT_APP_VERSION;
const dsn = window.env.REACT_APP_SENTRY_DSN;
const environment = window.env.REACT_APP_SENTRY_ENVIRONMENT;

export default new BrowserMicroSentryClient({
  dsn,
  environment,
  release,
});
